import z from "zod";

export const GestaoDistribuicaoEpiSchema = z.object({
  idFuncionario: z.coerce.number({
    required_error: "Este campo deve ser preenchido!",
  }),
  idGestaoRecebimentoEpi: z.array(z.coerce.number()).optional(),
  ca: z.string().nonempty("Este campo deve ser preenchido!").optional(),
  quantidade: z.coerce.number().nullable().default(null),
  dataEntrega: z.coerce.date().nullable().default(null),
  dataCadastro: z.coerce.date().nullable().default(null),
  idCentroCusto: z.coerce.number().nullable().default(null),
  idCentroCustoSaida: z.coerce.number().nullable().default(null),
  
  //Extra
  idCargo: z.coerce.number().nullable().default(null),
});

export type GestaoDistribuicaoEpiForm = z.infer<
  typeof GestaoDistribuicaoEpiSchema
>;
